import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSnackbar } from 'notistack';

const GlobalToastMessage = ({ toastMessage }) => {
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (toastMessage?.message) {
            enqueueSnackbar(toastMessage.message, {
                variant: toastMessage.toastType || 'default',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
        }
    }, [toastMessage]);

    return null;
}

const mapStateToProps = state => ({
    toastMessage: state.shareReducer.toastMessage
});

export default connect(mapStateToProps)(GlobalToastMessage);
